import { render, staticRenderFns } from "./QuickbuyVerificationDetails.vue?vue&type=template&id=101f7222&scoped=true&"
import script from "./QuickbuyVerificationDetails.vue?vue&type=script&lang=js&"
export * from "./QuickbuyVerificationDetails.vue?vue&type=script&lang=js&"
import style0 from "./QuickbuyVerificationDetails.vue?vue&type=style&index=0&id=101f7222&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101f7222",
  null
  
)

export default component.exports